var React = require('react');

function Opportunity (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"11.9986","cy":"7.46154","r":"4.46154","stroke":"currentColor","strokeWidth":"2","key":0}),React.createElement("path",{"d":"M9.23047 17.8461L10.6151 12.3076H13.3843L14.7689 17.8461L11.9997 20.6153L9.23047 17.8461Z","stroke":"currentColor","strokeWidth":"2","key":1}),React.createElement("path",{"d":"M18.9223 21.9999V16.3076C18.9223 14.0985 17.1315 12.3076 14.9223 12.3076H9.07617C6.86703 12.3076 5.07617 14.0985 5.07617 16.3076V21.9999","stroke":"currentColor","strokeWidth":"2","key":2})]);
}

Opportunity.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Opportunity;

Opportunity.default = Opportunity;
